// extracted by mini-css-extract-plugin
export default {"root":"classes_root__fpaDu","icon":"classes_icon__CIvI8"};